import { FragmentStore } from '../runtime/stores/fragment'
import artifact from '$houdini/artifacts/InventoryOptionValues'


// create the fragment store

export class InventoryOptionValuesStore extends FragmentStore {
	constructor() {
		super({
			artifact,
			storeName: "InventoryOptionValuesStore",
			variables: true,
			
		})
	}
}
